// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1H_XS","log":"ModalInventoryLogs_log__2Q1HS","date":"ModalInventoryLogs_date__2KWf0","userName":"ModalInventoryLogs_userName__3XKgD"};